import React from 'react'
import { Box, Tab } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import SupportCasestable from '../components/Support/SupportCasesTable';
import CaseHistoryTable from '../components/Support/CaseHistoryTable';
import CreateCase from '../components/Support/CreateCase';
import FAQ from '../components/Support/Faq';
import CaseDetails from "../components/Support/CaseDetails";



const SupportCenter = () => {

    const [value, setValue] = React.useState('1');
    const [caseDetail, setCase] = React.useState({});
    const [Show, setShow] = React.useState(false)

    const handleChange = (event, newValue) => {
        // debugger;
        event.preventDefault()
        setValue(newValue);
        setShow(false)
    };

    return (
        <div className='PageContainer'>
            <Box className='ContainerTab MainTab' sx={{ width: '100%' }}>
                <TabContext value={value}>
                    <Box className='' sx={{ borderBottom: 1, borderColor: 'divider', margin:"0 12px" }}>
                        <TabList onClick={() =>  setShow(false)} onChange={handleChange} aria-label="lab API tabs example">
                            <Tab  className='ContainertabName' label="Support cases" value="1" />
                            <Tab className='ContainertabName' label="case History" value="2" />
                            <Tab className='ContainertabName' label="Create case" value="3" />
                            <Tab className='ContainertabName' label="FAQ" value="4" />
                        </TabList>
                    </Box>
                    <TabPanel value="1">
                        {Show ? <CaseDetails data={caseDetail} /> :
                            <SupportCasestable showDetails={(caseDetail) => {
                                setCase(caseDetail);
                                setShow(true);
                            }}
                            handleAdd={() => setValue("3")}
                            />
                        }
                    </TabPanel>
                    <TabPanel value="2">
                        {Show ? <CaseDetails data={caseDetail} /> :
                            <CaseHistoryTable showDetails={(caseDetail) => {
                                setCase(caseDetail);
                                setShow(true);
                                
                            }} 
                            handleAdd={() => setValue("3")}
                            />
                        }
                    </TabPanel>
                    <TabPanel value="3">
                        <CreateCase />
                    </TabPanel>
                    <TabPanel value="4">
                        <FAQ />
                    </TabPanel>
                </TabContext>
            </Box>
        </div>
    )
}

export default SupportCenter